import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import HubspotForm from "react-hubspot-form";
import renderItem from "utils/renderItem";
import SkeletonLoader from "components/SkeletonLoader";
import { colors, resolveColor } from "utils/styles";
import { UserContext } from "contexts/";

export default function FormEmbed(props) {
	const { user } = useContext(UserContext);

	const fields = props.data.fields;

	const hashLink = fields?.hashLink;
	const horizontalAlign = fields?.horizontalAlign;
	const containerClasses = fields?.containerClasses || "d-flex  w-100 p-1 p-sm-2 p-md-4";
	const formClasses = fields?.formClasses || "d-flex flex-column p-4 boxShadow radius-5px";
	const submitButtonColor = fields?.submitButtonColor || "darkBlue";
	const backgroundColor = fields?.backgroundColor;

	const loggedInUserAlternateContent = fields?.loggedInUserAlternateContent;

	if (loggedInUserAlternateContent && user) {
		return (
			fields.loggedInUserAlternateContent &&
			fields.loggedInUserAlternateContent.map((component) => (
				<React.Fragment key={component.sys.id}>{renderItem(component)}</React.Fragment>
			))
		);
	}

	return (
		<Row id={hashLink} className={`g-0 justify-content-${horizontalAlign} ${containerClasses}`}>
			{fields.topComponents &&
				fields.topComponents.map((component) => (
					<React.Fragment key={component.sys.id}>{renderItem(component)}</React.Fragment>
				))}
			<Col xs={12} className={`${formClasses} formContainer`}>
				<HubspotForm
					className="w-100 "
					portalId={fields.portalId}
					formId={fields.formId}
					loading={<FormLoading />}
				/>
				{/* <FormLoading /> */}
			</Col>
			{fields.bottomComponents &&
				fields.bottomComponents.map((component) => (
					<React.Fragment key={component.sys.id}>{renderItem(component)}</React.Fragment>
				))}
			<style global jsx>{`
				.formContainer {
					max-width: ${fields.formMaxWidth || 600}px;
					background: ${resolveColor(backgroundColor)};
				}
				 {
					/* //HUB SPOT */
				}

				/* HubSpot forms might send you a list of radio buttons */
				form.hs-form .hs-form-field ul.inputs-list {
					list-style: none;
					padding: 0;
				}

				/* Radio inputs set wide:auto */
				input[type="radio"].hs-input {
					width: auto !important;
					margin-bottom: 0;
					margin-right: 0.5em;
				}

				input[type="checkbox"].hs-input {
					width: auto !important;
					margin-bottom: 0;
					margin-right: 0.5em;
				}
				/* text inputs are 100% wide,  */

				.hs-form-radio-display {
					padding: 0em 1em;
					display: flex;
					align-items: center;
					cursor: pointer;
					font-size: 20px;
					font-weight: bold;
				}
				.hs-form-radio-display:hover {
					background: ${colors["mediumGray"]};

					border-radius: 5px;
				}

				.hs-form .hs-input:not([type="checkbox"]) {
					width: 100%;
					border-radius: 5px;

					height: 2.5em;
					margin-bottom: 1em;
				}

				.hs-form label {
					font-weight: bold;
				}

				form.hs-form fieldset {
					max-width: none;
				}

				.hs-input[type="file"] {
					margin: 1em 0em;
					align-items: center;
				}
				.hs-input[type="file"]::-webkit-file-upload-button {
					background-color: ${colors["yellow"]};
					color: ${colors["white"]};

					display: inline-block;
					font-family: "Open Sans";
					/* line-height: 18px; */
					font-weight: bold;
					justify-content: space-evenly;
					transition: all 0.2s;
					border: none;

					cursor: pointer;
					text-decoration: none;
					border-radius: 5px;
				}

				.hs-button {
					align-items: center;
					min-height: 3em;
					margin-top: 2em;
					font-family: "Open Sans";
					line-height: 18px;
					font-weight: bold;
					display: flex;
					justify-content: space-evenly;
					transition: all 0.2s;
					border: none;
					text-decoration: none;
					border-radius: 5px;
					padding: 0 1em;
					font-size: 20px;
				}
				.hs-button[type="submit"],
				.hs-button[type="submit"]:hover {
					background: ${colors["green"]}!important;
					color: ${colors["white"]};
					padding: 0.1em 2em !important;
					font-size: 20px !important;
					line-height: 20px !important;
				}

				.hs-input[type="file"]::-webkit-file-upload-button:hover,
				.hs-button:hover {
					filter: brightness(110%);
					box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.4);
				}
				.hs-form textarea.hs-input {
					height: 150px;
				}
			`}</style>
		</Row>
	);
}

const FormLoading = () => {
	return (
		<div className="p-4 ">
			<Row className=" g-0">
				<Col className="mb-3 pe-2" xs={6}>
					<SkeletonLoader count={1} width="100%" height="2.5em" />
				</Col>
				<Col className="mb-3 ps-2" xs={6}>
					<SkeletonLoader count={1} width="100%" height="2.5em" />
				</Col>
			</Row>
			<SkeletonLoader className="mb-3 boxShadow" count={1} width="100%" height="2.5em" />
			<SkeletonLoader className="mb-3 boxShadow" count={1} width="100%" height="2.5em" />
			<SkeletonLoader className="mb-3 boxShadow" count={1} width="100%" height="2.5em" />
			<SkeletonLoader className="mb-3 boxShadow" count={1} width="100%" height="2.5em" />
			<SkeletonLoader className="mb-3 boxShadow" count={1} width="100%" height="4em" />
		</div>
	);
};
